export default "__VITE_ASSET__6304463d__"